// Permission constants based on StaticPermissions.cs
export const PERMISSIONS = {
  // Advertisements
  ADVERTISEMENTS: {
    VIEW: 'p_ad0001',
    ADD: 'p_ad0002',
    EDIT: 'p_ad0003',
    DELETE: 'p_ad0004',
  },
  
  // Brands
  BRANDS: {
    VIEW: 'p_b0001',
    ADD: 'p_b0002',
    EDIT: 'p_b0003',
    DELETE: 'p_b0004',
  },
  
  // Categories
  CATEGORIES: {
    VIEW: 'p_c0001',
    ADD: 'p_c0002',
    EDIT: 'p_c0003',
    DELETE: 'p_c0004',
  },
  
  // Roles
  ROLES: {
    VIEW: 'p_r0001',
    ADD: 'p_r0002',
    EDIT: 'p_r0003',
    DELETE: 'p_r0004',
  },
  
  // Discounts
  DISCOUNTS: {
    VIEW: 'p_di0001',
    ADD: 'p_di0002',
    EDIT: 'p_di0003',
    DELETE: 'p_di0004',
  },
  
  // Orders
  ORDERS: {
    VIEW: 'p_o0001',
    REJECT: 'p_o0002',
    EDIT_STATUS: 'p_o0003',
    ARCHIVE: 'p_o0004',
    CREATE: 'p_o0005',
    ASSIGN_DELIVERY: 'p_o0006',
    MY_DELIVERY_ORDERS: 'p_o0007',
  },
  
  // Products
  PRODUCTS: {
    VIEW: 'p_p0001',
    ADD: 'p_p0002',
    EDIT: 'p_p0003',
    DELETE: 'p_p0004',
  },
  
  // Promo Codes
  PROMO_CODES: {
    VIEW: 'p_pc0001',
    ADD: 'p_pc0002',
    EDIT: 'p_pc0003',
    DELETE: 'p_pc0004',
  },
  
  // Settings
  SETTINGS: {
    EDIT: 'p_s0001',
  },
  
  // Users
  USERS: {
    VIEW: 'p_u0001',
    ADD: 'p_u0002',
    EDIT: 'p_u0003',
    DELETE: 'p_u0004',
  },
  
  // Tickets
  TICKETS: {
    VIEW: 'p_t0001',
    CHANGE_STATUS: 'p_t0002',
    SEND_REPLY: 'p_t0003',
    ARCHIVE: 'p_t0004',
  },
  
  // Notifications
  NOTIFICATIONS: {
    VIEW: 'p_n0001',
    ADD: 'p_n0002',
    EDIT: 'p_n0003',
    DELETE: 'p_n0004',
    SEND: 'p_n0005',
  },
  
  // Dashboard
  DASHBOARD: {
    SUMMARY: 'p_d0001',
    CHART: 'p_d0002',
    TOP_GOVERNORATES: 'p_d0003',
    TOP_ORDERED_PRODUCTS: 'p_d0004',
    TOP_BUYERS: 'p_d0005',
    TOP_RETURNED_PRODUCTS: 'p_d0006',
    LATEST_REVIEWS: 'p_d0007',
  },
  
  // Suppliers
  SUPPLIERS: {
    VIEW: 'p_sup0001',
    ADD: 'p_sup0002',
    EDIT: 'p_sup0003',
    DELETE: 'p_sup0004',
  },

  // Purchase Invoices
  PURCHASE_INVOICES: {
    VIEW: 'p_pi0001',
    ADD: 'p_pi0002',
    EDIT: 'p_pi0003',
    DELETE: 'p_pi0004',
  },

  // Expenses
  EXPENSES: {
    VIEW: 'p_exp0001',
    ADD: 'p_exp0002',
    EDIT: 'p_exp0003',
    DELETE: 'p_exp0004',
  },

  // Expense Categories
  EXPENSE_CATEGORIES: {
    VIEW: 'p_ec0001',
    ADD: 'p_ec0002',
    EDIT: 'p_ec0003',
    DELETE: 'p_ec0004',
  },

  // Profit Reports
  PROFIT_REPORTS: {
    VIEW: 'p_pr0001',
  },

  // Locations
  LOCATIONS: {
    VIEW: 'p_lo0001',
    ADD: 'p_lo0002',
    EDIT: 'p_lo0003',
    DELETE: 'p_lo0004',
  },
  
  // Payments
  PAYMENTS: {
    VIEW: 'p_lo0001', // Note: This seems to be a duplicate of LOCATIONS.VIEW in the backend
  },

  // Doctor Commissions
  DOCTOR_COMMISSIONS: {
    VIEW: 'p_dc0001',
    MANAGE: 'p_dc0002',
    PAY: 'p_dc0003',
  },

  // Researcher Commissions
  RESEARCHER_COMMISSIONS: {
    VIEW: 'p_rc0001',
    MANAGE: 'p_rc0002',
    PAY: 'p_rc0003',
  },

  // Researchers
  RESEARCHERS: {
    VIEW: 'p_res0001',
    ADD: 'p_res0002',
    EDIT: 'p_res0003',
    DELETE: 'p_res0004',
  },

  // Audit Logs
  AUDIT_LOGS: {
    VIEW: 'p_al0001',
  },
} as const;

// Navigation permission mapping
export const NAVIGATION_PERMISSIONS = {
  // Main section
  DASHBOARD: [PERMISSIONS.DASHBOARD.SUMMARY],
  DOCTOR_POINTS: [],
  RESEARCHER_POINTS: [],
  PRODUCTS: [PERMISSIONS.PRODUCTS.VIEW],
  CATEGORIES: [PERMISSIONS.CATEGORIES.VIEW],
  ORDERS: [PERMISSIONS.ORDERS.VIEW],
  MY_COLLECTIONS: [PERMISSIONS.ORDERS.CREATE],
  CUSTOMERS: [PERMISSIONS.USERS.VIEW],
  DELIVERIES: [PERMISSIONS.ORDERS.MY_DELIVERY_ORDERS],
  PROMOTION: [PERMISSIONS.DISCOUNTS.VIEW, PERMISSIONS.PROMO_CODES.VIEW],
  NOTIFICATIONS: [PERMISSIONS.NOTIFICATIONS.VIEW],
  
  // General section
  INVENTORY: [PERMISSIONS.PRODUCTS.VIEW], // Assuming inventory is related to products
  LOCATIONS: [PERMISSIONS.LOCATIONS.VIEW],
  SETTINGS: [PERMISSIONS.SETTINGS.EDIT],
  KNET_TRANSACTIONS: [PERMISSIONS.PAYMENTS.VIEW],
  SUPPLIERS: [PERMISSIONS.SUPPLIERS.VIEW],
  PURCHASE_INVOICES: [PERMISSIONS.PURCHASE_INVOICES.VIEW],
  EXPENSES: [PERMISSIONS.EXPENSES.VIEW],
  PROFIT_REPORTS: [PERMISSIONS.PROFIT_REPORTS.VIEW],
  DOCTOR_COMMISSIONS: [PERMISSIONS.DOCTOR_COMMISSIONS.VIEW],
  RESEARCHER_COMMISSIONS: [PERMISSIONS.RESEARCHER_COMMISSIONS.VIEW],
  RESEARCHERS: [PERMISSIONS.RESEARCHERS.VIEW],
  AUDIT_LOGS: [PERMISSIONS.AUDIT_LOGS.VIEW],
} as const;

